import React from 'react';
// import AppContext from "../../AppContext";


const NBAHeader = ({hideHeader}) => {
  // const [input, setInput] = useState("");
  // const [valid, setValid] = useState(true);
  // const { passwordEntered, setPasswordEntered } = useContext(AppContext);
  

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (input !== pw) {
  //     setValid(false);
  //     setPasswordEntered(false);
  //   } else {
  //     setValid(true);
  //     setPasswordEntered(true);
  //     localStorage.setItem('passwordEntered', true);
  //   }
  // };

  return (<>
    <div className="w-full h-full overflow-hidden flex-none md:!flex hidden min-h-[60px]" style={{background: "url(/header.svg) #03265E center center / auto 100% no-repeat"}}>
      {/* <img
        src="/desktop-draft-combine-header.png"
        alt=""
        className="w-full h-full object-fill block"
        draggable={false}
      /> */}

    </div>
    <div className="w-full h-full overflow-hidden flex-none  md:hidden min-h-[60px]" style={{background: "url(/header-fat.svg) #03265E -30px center / auto 100% no-repeat"}}>
      {/* <img
        src="/header-fat.svg"
        alt=""
        className="w-full h-full object-fill block"
        draggable={false}
      /> */}
    </div>
  </>);
};
  
export default NBAHeader;